import { render, staticRenderFns } from "./NewCampaignMessageModal.vue?vue&type=template&id=1337e0aa"
import script from "./NewCampaignMessageModal.vue?vue&type=script&lang=js"
export * from "./NewCampaignMessageModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports